import { motion } from "framer-motion";

const FAQ = () => {

  const faqs = [
    {
      question: "How does Sera work?",
      answer: "Sera connects to your device's notification system and intelligently batches non-urgent notifications, delivering them at times you choose while letting important ones through immediately."
    },
    {
      question: "Is my data private?",
      answer: "Absolutely. Sera processes all notifications locally on your device. We don't collect, store, or transmit any of your personal data or notification content."
    },
    {
      question: "Can I customize notification priorities?",
      answer: "Yes! You can set which apps and contacts can break through your batching schedule, ensuring you never miss truly important notifications."
    },
    {
      question: "Does Sera work with all apps?",
      answer: "Sera works with any app that sends notifications through your device's standard notification system, including messaging, email, social media, and productivity apps."
    },
    {
      question: "Can I pause batching anytime?",
      answer: "Yes, you can instantly pause or resume batching with a single tap, giving you complete control over when you want to receive notifications."
    },
    {
      question: "Is Sera available on all devices?",
      answer: "Currently, Sera is available for Android devices. We're working on iOS support and will announce availability soon."
    }
  ];

  return (
    <section id="faq" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group cursor-pointer relative"
              whileHover={{ 
                y: -4,
                scale: 1.01,
                transition: { duration: 0.3, ease: "easeOut" }
              }}
              whileTap={{ scale: 0.99 }}
            >
              {/* Animated background glow effect - contained within the card */}
              <motion.div
                className="absolute inset-0 bg-gradient-to-r from-teal-400/20 to-blue-500/20 rounded-2xl opacity-0 group-hover:opacity-100 blur-xl -z-10"
                transition={{ duration: 0.3 }}
              />
              
              {/* Main content container */}
              <div className="relative z-10 p-6 rounded-2xl bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 group-hover:border-teal-400/30 transition-all duration-300">
                {/* Question with enhanced hover effects */}
                <motion.h3 
                  className="text-lg font-semibold mb-3 group-hover:text-teal-400 transition-colors duration-300"
                  whileHover={{
                    scale: 1.02,
                    transition: { duration: 0.2 }
                  }}
                >
                  {faq.question}
                </motion.h3>
                
                {/* Answer with hover effects */}
                <motion.p 
                  className="text-slate-400 group-hover:text-slate-300 transition-colors duration-300"
                  whileHover={{
                    y: -1,
                    transition: { duration: 0.2 }
                  }}
                >
                  {faq.answer}
                </motion.p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
